/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro, GRID_TREE_DATA_GROUPING_FIELD } from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';

import useReportContext from '../context/useReportContext';

function WeeklySummaryTable() {
  const { weeklyRerportColumn, reportData, exportWeeklySummary } = useContext(useReportContext);

  const columns = weeklyRerportColumn;

  const getTreeDataPath = (row) => row?.hierarchy;

  const groupingColDef = {
    headerName: ' ',
    cellClassName: ({ row }) => (row?.parent ? 'parent-heirarchy' : ''),
    width: 300,
  };

  const pinnedRows = {
    top: reportData.weekly_data.length ? [reportData.weekly_data[0]] : [],
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            color='success'
            onClick={exportWeeklySummary}
            sx={{
              marginLeft: '20px',
              marginBottom: '20px',
              paddingTop: '10px',
            }}
          >
            Export Weekly Summary
          </Button>
        </Box>
        <Box
          className='table-container'
          sx={{
            height: '800px',
            marginLeft: '20px',
            // '& .row-header': {
            //   backgroundColor: '#5cb85c',
            //   color: '#fff',
            //   fontSize: '15px',
            //   fontWeight: 'bold',
            // },
            '& .cell-green': {
              backgroundColor: '#5cb85c',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-yellow': {
              backgroundColor: '#f0ad4e',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-red': {
              backgroundColor: '#FFADB0',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-super-red': {
              backgroundColor: '#d9534f',
              color: '#000',
              fontWeight: '600',
            },
            '& .super-app-theme--header': {
              backgroundColor: '#169016',
              color: '#fff',
              fontWeight: 'bold',
            },
            '& .Mui-selected': {
              color: '#000',
              fontWeight: '600',
            },
            '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#cdf8cd' },
          }}
        >
          <DataGridPro
            treeData
            loading={reportData.weekly_loading}
            rows={reportData.weekly_data}
            columns={columns}
            getTreeDataPath={getTreeDataPath}
            groupingColDef={groupingColDef}
            initialState={{
              pinnedColumns: {
                left: [GRID_TREE_DATA_GROUPING_FIELD],
              },
            }}
            pinnedRows={pinnedRows}
            experimentalFeatures={{ rowPinning: true }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default WeeklySummaryTable;
